module.exports = __webpack_public_path__ + "media/assets/img/utilizatori-active-315f00652ead5b313b3748cbbf128bce.svg";